import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChartViewDTO } from '../../model/chart_view/chart-view-dto';
import { QuantiteDossierRecouvrementSuiviPortefeuilleDTO } from '../../model/QuantiteDossierRecouvrementSuiviPortefeuilleDTO';
import { QuantiteDossierRecouvrementDTO } from '../../model/QuantiteDossierRecouvrementDTO';

@Injectable({
  providedIn: "root"
})
export class DashboardDossierRecouvrementService {
  constructor(private _restClientService: RestClientService) {}


  quantiteDossierSuiviPortefeuilleRisque() {
    return this._restClientService.load<
      QuantiteDossierRecouvrementSuiviPortefeuilleDTO
    >(
      "dashboard-dossier-recouvrement/quantite-dossierDossier-recouvrement" 
    );
  }


  quantiteHistoriqueRecouvrement() {
    return this._restClientService.load<QuantiteDossierRecouvrementDTO[]>(
      "dashboard-dossier-recouvrement/historique-recouvrement"
    );
  }
}
